import React, { PureComponent } from 'react';
import styles from './Button.module.css';

export default class Button extends PureComponent {
  render() {
    const { text, onClick, style, height, white } = this.props;
    return (
      <button
        className={white ? styles.whiteButton : styles.button}
        style={{ ...style, height: height || '46px' }}
        onClick={onClick}
      >
        {text}
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Button/index.js